module.exports = __webpack_public_path__ + "static/media/empty-cartmate-icon.e3787030.svg";